var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h3',[_vm._v("About AChia")]),_c('p',[_vm._v("A generic website with nothing espeically useful.")])])}]

export { render, staticRenderFns }